module.exports = __webpack_public_path__ + "static/media/01-1-mobile.e55a6fa1.webp";